import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Container, Row, Col } from "react-bootstrap";
import { config } from "../../../constants";
import images from "../../../assets";
import { Button, Icon, IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, InputAdornment, Box, Typography } from "@material-ui/core";
import { MoreVert as MoreVertIcon, Visibility, VisibilityOff } from "@material-ui/icons";
import YodleeModal from "./yodleeModal";
import Verifyid from "../veifyid-data/verifyid";
import { OauthIntegrations } from "../../../services/requests";
import DiaModal from "./DiaModal";
import swal from "sweetalert";
import NisaBankVerification from "./NisaBankVerification";
import BankModal from "./BankModal";
import axios from "axios";

// Session timeout constants
const STANDARD_BANK_SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes
const NEDBANK_SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes
const FNB_SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes

// Standard Bank session helpers
const loadStandardBankSession = (profileId) => {
  const sessionKey = `standardBankSession_${profileId}`;
  const savedSession = localStorage.getItem(sessionKey);
  if (!savedSession) return null;

  try {
    const session = JSON.parse(savedSession);
    if (Date.now() - session.startedAt > STANDARD_BANK_SESSION_TIMEOUT) {
      localStorage.removeItem(sessionKey);
      return null;
    }
    return session;
  } catch (error) {
    localStorage.removeItem(sessionKey);
    return null;
  }
};

const clearStandardBankSession = (profileId) => {
  const sessionKey = `standardBankSession_${profileId}`;
  localStorage.removeItem(sessionKey);
};

// Nedbank session helpers
const loadNedbankSession = (profileId) => {
  const sessionKey = `nedbankSession_${profileId}`;
  const savedSession = localStorage.getItem(sessionKey);
  if (!savedSession) return null;

  try {
    const session = JSON.parse(savedSession);
    if (Date.now() - session.startedAt > NEDBANK_SESSION_TIMEOUT) {
      localStorage.removeItem(sessionKey);
      return null;
    }
    return session;
  } catch (error) {
    localStorage.removeItem(sessionKey);
    return null;
  }
};

const clearNedbankSession = (profileId) => {
  const sessionKey = `nedbankSession_${profileId}`;
  localStorage.removeItem(sessionKey);
};

// FNB session helpers
const loadFnbSession = (profileId) => {
  const sessionKey = `fnbSession_${profileId}`;
  const savedSession = localStorage.getItem(sessionKey);
  if (!savedSession) return null;

  try {
    const session = JSON.parse(savedSession);
    if (Date.now() - session.startedAt > FNB_SESSION_TIMEOUT) {
      localStorage.removeItem(sessionKey);
      return null;
    }
    return session;
  } catch (error) {
    localStorage.removeItem(sessionKey);
    return null;
  }
};

const clearFnbSession = (profileId) => {
  const sessionKey = `fnbSession_${profileId}`;
  localStorage.removeItem(sessionKey);
};

// Get active bank session
const getActiveBankSession = (profileId) => {
  const standardBankSession = loadStandardBankSession(profileId);
  const nedbankSession = loadNedbankSession(profileId);
  const fnbSession = loadFnbSession(profileId);

  if (standardBankSession && !["approved", "error", "failed"].includes(standardBankSession.status)) {
    return { bank: "Standard Bank", session: standardBankSession };
  }
  if (nedbankSession && !["approved", "error", "failed"].includes(nedbankSession.status)) {
    return { bank: "Nedbank", session: nedbankSession };
  }
  if (fnbSession && !["approved", "failed"].includes(fnbSession.status)) {
    return { bank: "FNB Bank", session: fnbSession };
  }

  return null;
};


@inject("verifyIdStore")
@inject("commonStore")
@inject("businessProfileStore")
@observer
class DataVerificationLink extends Component {
  constructor() {
    super();
    this.state = {
      sageData: {},
      showFastLinkModal: false,
      showSageOneModal: false,
      showDiaModal: false,
      isDiaOpened: false,
      directorDetails: [],
      dirSavedCapturedImg: null,
      isExtensionInstalled: true,
      holderName : null,
      accountBalance: null,
      bankData: null,
      // Change Credentials state
      anchorEl: null,
      showChangeCredentialsModal: false,
      newEmail: '',
      newPassword: '',
      connectedBankSlug: '',
      isUpdatingCredentials: false,
      showPassword: false,
      // Active session state
      activeSession: null,
      show: false
    };
    this.sessionCheckInterval = null;
  }

  async componentDidMount() {
    const { commonStore } = this.props;
    let img = new Image();
    img.src = `chrome-extension://${config.NISADOCLOCK_EXTENSION_ID}/logos/logo_16.png`;
    img.onload = () => this.setState({ isExtensionInstalled: true });
    img.onerror = () => this.setState({ isExtensionInstalled: false });
    await this.fetchBankData();

    // Check for active sessions periodically
    this.checkActiveSessions();
    this.sessionCheckInterval = setInterval(() => {
      this.checkActiveSessions();
    }, 2000); // Check every 2 seconds
  }

  componentWillUnmount() {
    // Clear interval on unmount
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
    }
  }

  checkActiveSessions = () => {
    const { commonStore } = this.props;
    const profile = commonStore.user?.profile;
    if (!profile) return;

    const activeSession = getActiveBankSession(profile);
    this.setState({ activeSession });
  };

  fetchBankData = async () => {
    const { commonStore } = this.props;
    // Defensive: Check if user and profile exist before making API call
    if (commonStore?.user?.profile) {
      const res = await OauthIntegrations.getBankdata(commonStore.user.profile);
      this.setState({ bankData: res?.data.data });
      console.log("bank data response", res?.data?.data);
    } else {
      console.warn('Cannot fetch bank data: user profile not available');
    }
  };

  onFastLinkClose = (error) => {
    if (error) {
      console.error("FastLink Error:", error);
      // Provide additional error handling or feedback as needed
      // For example, you might want to show a user-friendly message
      // this.props.showErrorMessage('An error occurred during the FastLink process.');
    }
    window.fastlink.close();
    this.setState({ showFastLinkModal: false });
    this.props.updateProviderData();
  };
  onSageOneClose = () => {
    this.setState({ showSageOneModal: false });
  };
  onShowDiaClose = () => {
    this.setState({ showDiaModal: false, isDiaOpened: true });
    video.pause();
    let tracks = video.srcObject.getTracks();
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      track.stop();
    }
    video.srcObject = null;
  };

  onFastLinkSuccess = async () => {
    this.setState({ showFastLinkModal: false });
    await OauthIntegrations.fetchYodleeData();
    this.props.updateProviderData();
  };

  removeSagedata = async () => {
    await OauthIntegrations.removeSagedata();
    this.props.updateProviderData();
  };

  removeXerodata = async () => {
    try {
      const { commonStore } = this.props;
      commonStore.setLoading(true);

      const response = await OauthIntegrations.removeXerodata();

      // Refresh provider data to update UI
      await this.props.updateProviderData();

      commonStore.setLoading(false);
      await commonStore.setMsg('Xero account disconnected successfully');
    } catch (error) {
      console.error('Error removing Xero data:', error);
      const { commonStore } = this.props;
      commonStore.setLoading(false);
      await commonStore.setMsg('Error disconnecting Xero account. Please try again.');
    }
  };

  removeYodleedata = async () => {
    await OauthIntegrations.removeYodleedata();
    this.props.updateProviderData();
  };

  handleDeleteAllBanks = async () => {
    const { bankData } = this.state;
    const { commonStore } = this.props;

    // Close menu first
    this.handleMenuClose();

    // Show confirmation dialog
    const result = await swal({
      title: "Are you sure?",
      text: "This will disconnect all bank verifications. You can reconnect later if needed.",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!result) {
      return;
    }

    try {
      // Show loading
      swal({
        title: "Deleting...",
        text: "Please wait while we disconnect bank verification.",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      // Build array of delete promises for all connected banks
      const deletePromises = [];

      if (bankData?.standardBank) {
        const deleteEndpoint = `${config.BANK_API_URL}/api/standardbank/delete/${bankData.standardBank.profile}`;
        deletePromises.push(axios.delete(deleteEndpoint, {
          headers: {
            'X-Tenant-ID': config.TENANT_ID
          }
        }));
      }

      if (bankData?.fnbBank) {
        const deleteEndpoint = `${config.BANK_API_URL}/api/fnbBank/delete/${bankData.fnbBank.profile}`;
        deletePromises.push(axios.delete(deleteEndpoint, {
          headers: {
            'X-Tenant-ID': config.TENANT_ID
          }
        }));
      }

      if (bankData?.nedbank) {
        const deleteEndpoint = `${config.BANK_API_URL}/api/nedbank/delete/${bankData.nedbank.profile}`;
        deletePromises.push(axios.delete(deleteEndpoint, {
          headers: {
            'X-Tenant-ID': config.TENANT_ID
          }
        }));
      }

      // Execute all delete operations in parallel
      await Promise.all(deletePromises);

      // Close loading and show success message
      await swal({
        title: "Success!",
        text: "Bank verification disconnected successfully",
        icon: "success",
        button: "OK",
      });

      // Refresh bank data to update UI
      await this.fetchBankData();
    } catch (error) {
      console.error('Error deleting bank connections:', error);
      await swal({
        title: "Error",
        text: error.response?.data?.message || "Failed to disconnect bank verification. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  };

  // Menu handlers
  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  // Change Credentials handlers
  handleOpenChangeCredentials = () => {
    const { bankData } = this.state;
    let connectedBankSlug = '';
    let currentEmail = '';

    // Detect which bank is connected
    if (bankData?.standardBank) {
      connectedBankSlug = 'standard';
      currentEmail = bankData.standardBank.email || '';
    } else if (bankData?.fnbBank) {
      connectedBankSlug = 'fnb';
      currentEmail = bankData.fnbBank.email || '';
    } else if (bankData?.nedbank) {
      connectedBankSlug = 'nedbank';
      currentEmail = bankData.nedbank.email || '';
    }

    this.setState({
      showChangeCredentialsModal: true,
      connectedBankSlug,
      newEmail: currentEmail,
      newPassword: '',
      anchorEl: null // Close menu
    });
  };

  handleCloseChangeCredentials = () => {
    this.setState({
      showChangeCredentialsModal: false,
      newEmail: '',
      newPassword: '',
      showPassword: false
    });
  };

  handleUpdateCredentials = async () => {
    const { newEmail, newPassword, connectedBankSlug } = this.state;
    const { commonStore } = this.props;

    // Validation
    if (!newEmail || !newEmail.trim()) {
      await swal({
        title: "Validation Error",
        text: "Please enter an email address",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    if (!newPassword || !newPassword.trim()) {
      await swal({
        title: "Validation Error",
        text: "Please enter a password",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      await swal({
        title: "Validation Error",
        text: "Please enter a valid email address",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    // Defensive: Check if profile exists before making API call
    const profileId = commonStore?.user?.profile;
    if (!profileId) {
      await swal({
        title: "Error",
        text: "User profile not available. Please refresh and try again.",
        icon: "error",
        button: "OK",
      });
      return;
    }

    try {
      this.setState({ isUpdatingCredentials: true });

      const updateEndpoint = `${config.BANK_API_URL}/api/credentials/updateCredentials`;

      await axios.put(updateEndpoint, {
        profileId,
        bankSlug: connectedBankSlug,
        email: newEmail.trim(),
        password: newPassword
      });

      this.setState({ isUpdatingCredentials: false });
      this.handleCloseChangeCredentials();

      await swal({
        title: "Success!",
        text: "Credentials updated successfully",
        icon: "success",
        button: "OK",
      });

      // Refresh bank data to update UI
      await this.fetchBankData();
    } catch (error) {
      console.error('Error updating credentials:', error);
      this.setState({ isUpdatingCredentials: false });

      await swal({
        title: "Error",
        text: error.response?.data?.message || "Failed to update credentials. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  };

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };

  handleCancelSession = async (bankName) => {
    const confirmed = await swal({
      title: "Cancel Session?",
      text: `Are you sure you want to cancel the ${bankName} session?`,
      icon: "warning",
      buttons: ["No, keep it", "Yes, cancel"],
      dangerMode: true,
    });

    if (!confirmed) return;

    try {
      const { commonStore } = this.props;
      const profile = commonStore.user?.profile;

      // Determine which bank and clear localStorage
      let endpoint = "";
      if (bankName === "Standard Bank") {
        clearStandardBankSession(profile);
        endpoint = `${config.BANK_API_URL}/api/standardBank/resetStatus`;
      } else if (bankName === "Nedbank") {
        clearNedbankSession(profile);
        endpoint = `${config.BANK_API_URL}/api/nedbank/resetStatus`;
      } else if (bankName === "FNB Bank") {
        clearFnbSession(profile);
        endpoint = `${config.BANK_API_URL}/api/fnbBank/resetStatus`;
      }

      // Call reset API to set backend status to initial
      if (endpoint) {
        await axios.post(endpoint, {
          profileId: profile
        });
      }

      // Clear active session state to hide pill
      this.setState({ activeSession: null });

      swal("Session Cancelled", "You can now start a new session.", "success");
    } catch (error) {
      console.error("Error cancelling session:", error);
      swal("Error", "Failed to cancel session. Please try again.", "error");
    }
  };

  goToAccount = async (
    accountName,
    clientId,
    redirectUri,
    scope,
    prefixUri
  ) => {
    try {
      if (accountName === "yodlee") {
        const { data = null } = await OauthIntegrations.getYodleeAccessToken();
        if (data && data.token && data.token.accessToken) {
          this.setState({ showFastLinkModal: true });
          const Thousand = 1000;
          setTimeout(() => {
            if (window.fastlink && typeof window.fastlink.open === 'function') {
              window.fastlink.open(
                {
                  fastLinkURL:
                    "https://fl4.sandbox.yodlee.com/authenticate/restserver/fastlink",
                  accessToken: `Bearer ${data.token.accessToken}`,
                  params: {
                    configName: "Aggregation",
                  },
                  onSuccess: this.onFastLinkSuccess,
                  // onError: this.onFastLinkClose,
                  onError: this.onFastLinkClose.bind(this), // Error callback

                  onExit: this.onFastLinkClose,
                },
                "container-fastlink"
              );
            } else {
              console.error('Fastlink is not available');
            }
          }, Thousand);
        }
      }
      if (accountName === "xero") {
        if (!prefixUri || !clientId || !scope || !redirectUri) {
          console.error('Missing required OAuth parameters for Xero');
          return;
        }
        const three = 3,
          thirtySix = 36;
        const randomString = Math.random().toString(thirtySix).substring(three);
        this.props.businessProfileStore.randomString = randomString;
        window.location = `${prefixUri}&client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&state=${randomString}`;
      }
    } catch (error) {
      console.error('Error in goToAccount:', error);
    }
    if (accountName === "sageone") {
      this.setState({ showSageOneModal: true });
    }
    if (accountName === "dia") {
      // Defensive: Check if businessProfile exists before accessing id
      const BusinessId = this.props.commonStore.businessProfile?.id;
      if (!BusinessId) {
        console.error('Cannot open DIA: business profile ID not available');
        return false;
      }

      let { data } = await OauthIntegrations.getSavedCapturedData(BusinessId);
      let { companyDirectors } = this.props.businessProfileStore;
      let directorDetails = companyDirectors.map((director) => {
        return {
          idNo: director.idNo,
          name: `${director.firstName} ${director.lastName}`,
        };
      });
      // comment out the next line
      directorDetails = [
        { idNo: 9605085341086, name: "Thando" },
        { idNo: 9709306081081, name: "Sinqobile" },
        { idNo: 980129542008, name: "shobhit" },
      ];
      this.setState({
        showDiaModal: true,
        directorDetails: directorDetails,
        dirSavedCapturedImg: data.dirSavedCapturedImg,
      });
    }
    return false;
  };

  updateSageData = async (obj) => {
    this.setState({ sageData: { ...obj } });
    await OauthIntegrations.setAuthData({
      ...obj,
      provider: "sageone",
    });
  };
  sageFormData = async (username, password) => {
    const data = await OauthIntegrations.setSage({ username, password });
    this.props.updateProviderData();
    this.onSageOneClose();
  };

  updateSageData = async (obj) => {
    //NOSONAR
    this.setState({ sageData: { ...obj } });
    await OauthIntegrations.setAuthData({
      ...obj,
      provider: "sageone",
    });
  };

  openExtensionPage = async () => {
    swal({
      title: "🌟 Coming Soon! 🌟",
      text: "We are working hard to bring you something amazing. Stay tuned for updates!",
      background: "#f3f4f6",
      confirmButtonText: "Got it!",
      confirmButtonColor: "#007bff",
    });

    // window.open("https://www.google.com", "_blank");
  };
  render() {
    const { providerAuthData } = this.props;
    // Defensive: Use optional chaining to prevent null reference errors
    const check = this.props.commonStore?.businessProfile;
    const { bankData } = this.state;

    const showAfterConnectCheck = () => {
      if (check && check.verifyid !== "") {
        return true;
      }
    };

    // Helper functions to check if bank data is valid (has actual data, not just approved status)
    const hasStandardBankData = (bankData) => {
      if (!bankData?.standardBank) return false;
      const { accounts, transactions } = bankData.standardBank;
      return (
        (Array.isArray(accounts) && accounts.length > 0) ||
        (Array.isArray(transactions) && transactions.length > 0)
      );
    };

    const hasFnbBankData = (bankData) => {
      if (!bankData?.fnbBank) return false;
      const { accounts, transaction } = bankData.fnbBank;
      return (
        (Array.isArray(accounts) && accounts.length > 0) ||
        (Array.isArray(transaction) && transaction.length > 0)
      );
    };

    const hasNedbankData = (bankData) => {
      if (!bankData?.nedbank) return false;
      const { transactions, accountHolderName, availableBalance } = bankData.nedbank;
      return (
        (Array.isArray(transactions) && transactions.length > 0) ||
        (accountHolderName && availableBalance)
      );
    };
    return (
      <div>
        <div className="p-h-15" style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
          <p>
            In order to verify the contents of your business profile and provide
            you loan , we reuire you to linking the following accounts to
            provide us with additional information about your business.
          </p>
        </div>
        <div className="tenth-step">
          <Container fluid={true}>
            <Row>
              <Col>
                <h3>Link Accounts</h3>
              </Col>
            </Row>
            {/* {!this.state.isExtensionInstalled && (
              <AccountList
                title="NISA DOCLOCK (EXTENSION)"
                img={images.nisaDoclockLogo}
                slug="NisaDoclock"
                actionFunction={this.openExtensionPage}
                actionName="add"
              />
            )} */}
            {providerAuthData &&
              providerAuthData.map((v) => {
                if (v.provider === "xero" && !v.hasValidToken) {
                  return (
                    <AccountList
                      title="XERO (ACCOUNTING)"
                      img={images.xeroLogo}
                      slug="xero"
                      actionFunction={this.goToAccount}
                      actionName="add"
                      key={v.provider}
                      {...v}
                    />
                  );
                }
                // if (v.provider === "sageone" && !v.hasValidToken) {
                //   return (
                //     <AccountList
                //       title="SAGE ONE (ACCOUNTING)"
                //       img={images.sageoneLogo}
                //       slug="sageone"
                //       actionFunction={this.goToAccount}
                //       actionName="add"
                //       key={v.provider}
                //       updateSageData={this.updateSageData}
                //       {...v}
                //     />
                //   );
                // }
                // if (v.provider === "yodlee" && !v.hasValidToken) {
                //   return (
                //     <AccountList
                //       title="YODLEE (BANK ACCOUNT)"
                //       img={images.yodleeLogo}
                //       slug="yodlee"
                //       actionFunction={this.goToAccount}
                //       actionName="add"
                //       key={v.provider}
                //       {...v}
                //     />
                //   );
                // }
                if (v.provider === "DIA" && !v.hasValidToken) {
                  return (
                    <AccountList
                      title="DIA (FACE VERIFICATION)"
                      img={images.diaLogo}
                      slug="dia"
                      actionFunction={this.goToAccount}
                      actionName="add"
                      key={v.provider}
                      {...v}
                    />
                  );
                }
                return null;
              })}
              {/* Modal for intiating the web scrapping - Only show when NO bank has valid data */}
              {!(bankData?.standardBank?.status === "approved" && hasStandardBankData(bankData)) &&
               !hasFnbBankData(bankData) &&
               !hasNedbankData(bankData) && (
                <NisaBankVerification
                title="NISA (BANK VERIFICATION)"
                img={{ fnb: images.fnb, standard: images.standardEmblem, nedbank: images.nedbank }}
                slug="fnb&Standard"
                holderName={this.state.holderName}
                balance={this.state.accountBalance}
                actionName="add"
                />
              )}
            {showAfterConnectCheck() !== true ? <Verifyid /> : null}
            <h3>
              <hr />
              Existing Linked Accounts
            </h3>
            {providerAuthData &&
              providerAuthData.map((v) => {
                if (v.provider === "xero" && v.hasValidToken) {
                  return (
                    <AccountList
                      title="XERO (ACCOUNTING)"
                      img={images.xeroLogo}
                      slug="xero"
                      actionFunction={this.removeXerodata}
                      actionName="delete"
                      key={v.provider}
                      {...v}
                    />
                  );
                }
                if (v.provider === "sageone" && v.hasValidToken) {
                  return (
                    <AccountList
                      title="SAGE ONE (ACCOUNTING)"
                      img={images.sageoneLogo}
                      slug="sageone"
                      actionFunction={this.removeSagedata}
                      actionName="delete"
                      key={v.provider}
                      updateSageData={this.updateSageData}
                      {...v}
                    />
                  );
                }
                // if (v.provider === "yodlee" && v.hasValidToken) {
                //   return (
                //     <AccountList
                //       title="YODLEE (BANK ACCOUNT)"
                //       img={images.yodleeLogo}
                //       slug="yodlee"
                //       actionFunction={this.removeYodleedata}
                //       actionName="delete"
                //       key={v.provider}
                //       {...v}
                //     />
                //   );
                // }
                if (v.provider === "DIA" && v.hasValidToken) {
                  return (
                    <AccountList
                      title="DIA (FACE VERIFICATION)"
                      img={images.diaLogo}
                      slug="dia"
                      actionFunction={this.goToAccount}
                      actionName="edit"
                      key={v.provider}
                      {...v}
                    />
                  );
                }
                return null;
              })}
            {/* Show NISA (BANK VERIFICATION) in existing accounts ONLY when ANY bank has valid data */}
            {((bankData?.standardBank?.status === "approved" && hasStandardBankData(bankData)) ||
              hasFnbBankData(bankData) ||
              hasNedbankData(bankData)) && (
              <Row className="mt-3 align-items-center" key="nisa-bank-connected">
                <Col md={{ span: 4 }}>NISA (BANK VERIFICATION)</Col>
                <Col md={{ span: 5 }} className="d-flex align-items-center">
                  <div className="w-50 text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '46px', gap: '8px' }}>
                    <img src={images.fnb} alt="FNB Bank" style={{ maxHeight: "35px", objectFit: "contain" }} />
                    <img src={images.standardEmblem} alt="Standard Bank" style={{ maxHeight: "28px", objectFit: "contain" }} />
                    <img src={images.nedbank} alt="Nedbank" style={{ maxHeight: "50px", objectFit: "contain" }} />
                  </div>
                  <IconButton
                    color="primary"
                    onClick={this.handleMenuOpen}
                    aria-label="more options"
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                  >
                    <MenuItem onClick={this.handleOpenChangeCredentials}>
                      <Icon style={{ marginRight: '8px' }}>edit</Icon>
                      Change Credentials
                    </MenuItem>
                    <MenuItem onClick={this.handleDeleteAllBanks} style={{ color: '#d32f2f' }}>
                      <Icon style={{ marginRight: '8px' }}>delete</Icon>
                      Delete Connection
                    </MenuItem>
                  </Menu>
                </Col>
              </Row>
            )}

            {showAfterConnectCheck() === true ? <Verifyid /> : null}
          </Container>
          {/* <div className="float-right text-sm-right">
               <button className="btn btn-info">Save</button>
            </div> */}
          <YodleeModal
            show={this.state.showFastLinkModal}
            onHide={this.onFastLinkClose}
          ></YodleeModal>
          <YodleeModal
            show={this.state.showSageOneModal}
            onHide={this.onSageOneClose}
            sageone={true}
            sageFormData={this.sageFormData}
          ></YodleeModal>
          <DiaModal
            show={this.state.showDiaModal}
            onHide={this.onShowDiaClose}
            isDiaOpened={this.state.isDiaOpened}
            businessId={this.props.commonStore.businessProfile?.id}
            directorDetails={this.state.directorDetails}
            dirSavedCapturedImg={this.state.dirSavedCapturedImg}
          />

          {/* Change Credentials Modal */}
          <Dialog
            open={this.state.showChangeCredentialsModal}
            onClose={this.handleCloseChangeCredentials}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              Update Bank Credentials
              {this.state.connectedBankSlug && (
                <div style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
                  Updating credentials for{' '}
                  {this.state.connectedBankSlug === 'standard' && 'Standard Bank'}
                  {this.state.connectedBankSlug === 'fnb' && 'FNB'}
                  {this.state.connectedBankSlug === 'nedbank' && 'Nedbank'}
                </div>
              )}
            </DialogTitle>
            <DialogContent>
              <TextField
                label="Email"
                type="email"
                fullWidth
                margin="normal"
                value={this.state.newEmail}
                onChange={(e) => this.setState({ newEmail: e.target.value })}
                disabled={this.state.isUpdatingCredentials}
                required
                autoFocus
              />
              <TextField
                label="Password"
                type={this.state.showPassword ? 'text' : 'password'}
                fullWidth
                margin="normal"
                value={this.state.newPassword}
                onChange={(e) => this.setState({ newPassword: e.target.value })}
                disabled={this.state.isUpdatingCredentials}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.togglePasswordVisibility}
                        disabled={this.state.isUpdatingCredentials}
                        edge="end"
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseChangeCredentials}
                color="default"
                disabled={this.state.isUpdatingCredentials}
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleUpdateCredentials}
                color="primary"
                variant="contained"
                disabled={this.state.isUpdatingCredentials}
              >
                {this.state.isUpdatingCredentials ? (
                  <>
                    <CircularProgress size={20} style={{ marginRight: '8px' }} />
                    Updating...
                  </>
                ) : (
                  'Update'
                )}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

const AccountList = (props) => {
  //NOSONAR
  const {
    title,
    slug,
    actionFunction,
    actionName,
    img,
    clientId,
    redirectUri,
    scope,
    prefixUri,
  } = props;
  return (
    <Row className="mt-3 align-items-center">
      <Col md={{ span: 4 }}>{title}</Col>
      <Col md={{ span: 5 }} className="d-flex align-items-center">
        <>
          <div className="w-50 text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '46px' }}>
            <img src={img} alt="img" style={{ maxHeight: "40px", maxWidth: "100%", objectFit: "contain" }} />
          </div>
          <Button
            color="primary"
            onClick={() =>
              actionFunction(slug, clientId, redirectUri, scope, prefixUri)
            }
          >
            <Icon color="primary">{actionName}</Icon>
          </Button>
        </>
      </Col>
    </Row>
  );
};


export default DataVerificationLink;
